// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../work/nmcp-client/nmcp-client/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * Copyright 2020 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

:root {
  --neuroglancer-segment-list-width: auto;
}

.neuroglancer-segment-list {
  position: relative;
  overflow-y: auto;
  overflow-x: auto;
  flex: 1;
}

.neuroglancer-segment-display-tab {
  display: flex;
  flex-direction: column;
}

.neuroglancer-segment-query-errors {
  margin: 0px;
  list-style-type: none;
  padding: 0px;
  padding-left: 3px;
  background-color: #333;
}

.neuroglancer-segment-query-errors > li {
  display: block;
  color: red;
}

.neuroglancer-segment-list-entry:not(
    .neuroglancer-segment-list-entry-double-line
  )
  .neuroglancer-segment-list-entry-unmapped-id:empty
  + .neuroglancer-segment-list-entry-copy {
  display: none;
}

.neuroglancer-segment-list-entry.neuroglancer-segment-list-entry-double-line
  .neuroglancer-segment-list-entry-unmapped-id:empty
  + .neuroglancer-segment-list-entry-copy {
  visibility: hidden;
}

.neuroglancer-segment-list-entry-name:empty
  + .neuroglancer-segment-list-entry-filter {
  display: none;
}

.neuroglancer-segment-list-entry-name {
  order: 1000;
  display: inline-block;
  font-family: monospace;
  font-size: medium;
  user-select: text;
  white-space: nowrap;
}

.neuroglancer-segment-list-query {
  background-color: #151515;
  color: white;
  font-family: monospace;
  font-size: medium;
  border: 2px solid #333;
  padding: 2px;
  outline: 0px;
}

.neuroglancer-segment-list-query::placeholder {
  color: #aaa;
}

.neuroglancer-segment-list-status {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #333;
}

.neuroglancer-segment-list-entry-copy {
  order: -2;
  visibility: hidden;
}

.neuroglancer-segment-list-entry:hover .neuroglancer-segment-list-entry-copy {
  visibility: visible;
}

.neuroglancer-segment-list
  .neuroglancer-segment-list-entry:not(:hover)
  .neuroglancer-star-icon:not(.neuroglancer-starred) {
  visibility: hidden;
}

.neuroglancer-segment-list
  .neuroglancer-segment-list-entry:not(:hover)
  .neuroglancer-eye-icon:not(.neuroglancer-visible) {
  visibility: hidden;
}

.neuroglancer-segment-list-entry-visible-checkbox {
  order: 1;
}

.neuroglancer-segment-list-entry-filter {
  visibility: hidden;
  grid-column: filter;
  order: 999;
}

.neuroglancer-segment-list-entry:hover .neuroglancer-segment-list-entry-filter {
  visibility: visible;
}

.neuroglancer-segment-query-result-tag-list {
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: [include] min-content [exclude] min-content [tag] 1fr [count] min-content;
}

.neuroglancer-segment-query-result-tag {
  display: contents;
}

.neuroglancer-segment-query-result-tag:hover * {
  background-color: #222;
}

.neuroglancer-segment-query-result-tag-name {
  grid-column: tag;
  white-space: nowrap;
  cursor: pointer;
  font-weight: bold;
}

.neuroglancer-segment-query-result-tag-name::before {
  content: "#";
  color: #aaa;
  font-weight: normal;
}

.neuroglancer-segment-query-result-tag-toggle {
  display: inline-block;
  white-space: nowrap;
}

.neuroglancer-segment-query-result-tag-include {
  grid-column: include;
}

.neuroglancer-segment-query-result-tag-exclude {
  grid-column: exclude;
}

.neuroglancer-segment-query-result-statistics {
  background-color: #333;
  max-height: 30%;
  flex-shrink: 0;
  overflow: auto;
}

.neuroglancer-segment-query-result-statistics:not(:empty) {
  padding-top: 3px;
}

.neuroglancer-segment-query-result-statistics:not(:empty)
  + .neuroglancer-segment-list-status {
  border-top: 1px solid white;
}

.neuroglancer-segment-query-result-statistics-separator {
  height: 3px;
  background-color: #333;
  border-bottom: 1px solid white;
}

.neuroglancer-segment-query-result-tag-count {
  grid-column: count;
  text-align: right;
}

.neuroglancer-segment-query-result-tag-count:not(:empty)::before {
  content: "(";
  color: #aaa;
}

.neuroglancer-segment-query-result-tag-count:not(:empty)::after {
  content: ")";
  color: #aaa;
}

.neuroglancer-segment-query-result-numerical-list {
  display: flex;
  flex-direction: column;
}

.neuroglancer-segment-query-result-numerical-plot-container {
  justify-self: stretch;
  display: flex;
  flex-direction: column;
  padding: 2px;
}

.neuroglancer-segment-query-result-numerical-plot {
  display: block;
  height: 30px;
  cursor: ew-resize;
  justify-self: stretch;
  border: 1px solid #666;
}

.neuroglancer-segment-query-result-numerical-plot-bound {
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
  border: 0;
  margin: 0;
  font: 10pt sans-serif;
  pointer-events: auto;
}

.neuroglancer-segment-query-result-numerical-plot-window-bound {
  color: cyan;
}

.neuroglancer-segment-query-result-numerical-plot-range-bound {
  color: white;
}

.neuroglancer-segment-query-result-numerical-plot-bounds {
  display: flex;
  flex-direction: row;
  color: #aaa;
}

.neuroglancer-segment-query-result-numerical-plot-bound-constraint-symbol {
  align-self: center;
}

.neuroglancer-segment-query-result-numerical-plot-bound-constraint-spacer {
  flex: 1;
  color: white;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.neuroglancer-segment-query-result-numerical-plot-label {
  cursor: pointer;
}

.neuroglancer-segment-query-result-numerical-plot-sort,
.neuroglancer-segment-list-header-label-sort {
  visibility: hidden;
}

.neuroglancer-segment-query-result-numerical-plot-label:hover
  .neuroglancer-segment-query-result-numerical-plot-sort,
.neuroglancer-segment-list-header-label:hover
  .neuroglancer-segment-list-header-label-sort {
  visibility: visible;
}

.neuroglancer-segment-query-result-numerical-plot-container:hover
  .neuroglancer-segment-query-result-numerical-plot-bounds-window {
  visibility: visible;
}

.neuroglancer-segment-query-result-numerical-plot-bounds-window {
  justify-content: space-between;
  margin-top: -16px;
  visibility: hidden;
  pointer-events: none;
}

.neuroglancer-segment-list-entry.neuroglancer-segment-list-header {
  background-color: #666;
}

.neuroglancer-segment-list-header .neuroglancer-segment-list-entry-id {
  background-color: inherit;
  color: white;
  text-align: center;
}

.neuroglancer-segment-list-header-label {
  cursor: pointer;
  font: 10pt sans-serif;
}

.neuroglancer-segment-list-header
  .neuroglancer-segment-list-entry-extra-property {
  text-align: center;
}

.neuroglancer-segment-list-status-message {
  overflow: hidden;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./../../../../nmcp-neuroglancer/dist/package/lib/ui/segment_list.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gGAAgG;AAClG;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,SAAS;EACT,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["/**\n * @license\n * Copyright 2020 Google Inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n:root {\n  --neuroglancer-segment-list-width: auto;\n}\n\n.neuroglancer-segment-list {\n  position: relative;\n  overflow-y: auto;\n  overflow-x: auto;\n  flex: 1;\n}\n\n.neuroglancer-segment-display-tab {\n  display: flex;\n  flex-direction: column;\n}\n\n.neuroglancer-segment-query-errors {\n  margin: 0px;\n  list-style-type: none;\n  padding: 0px;\n  padding-left: 3px;\n  background-color: #333;\n}\n\n.neuroglancer-segment-query-errors > li {\n  display: block;\n  color: red;\n}\n\n.neuroglancer-segment-list-entry:not(\n    .neuroglancer-segment-list-entry-double-line\n  )\n  .neuroglancer-segment-list-entry-unmapped-id:empty\n  + .neuroglancer-segment-list-entry-copy {\n  display: none;\n}\n\n.neuroglancer-segment-list-entry.neuroglancer-segment-list-entry-double-line\n  .neuroglancer-segment-list-entry-unmapped-id:empty\n  + .neuroglancer-segment-list-entry-copy {\n  visibility: hidden;\n}\n\n.neuroglancer-segment-list-entry-name:empty\n  + .neuroglancer-segment-list-entry-filter {\n  display: none;\n}\n\n.neuroglancer-segment-list-entry-name {\n  order: 1000;\n  display: inline-block;\n  font-family: monospace;\n  font-size: medium;\n  user-select: text;\n  white-space: nowrap;\n}\n\n.neuroglancer-segment-list-query {\n  background-color: #151515;\n  color: white;\n  font-family: monospace;\n  font-size: medium;\n  border: 2px solid #333;\n  padding: 2px;\n  outline: 0px;\n}\n\n.neuroglancer-segment-list-query::placeholder {\n  color: #aaa;\n}\n\n.neuroglancer-segment-list-status {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  background-color: #333;\n}\n\n.neuroglancer-segment-list-entry-copy {\n  order: -2;\n  visibility: hidden;\n}\n\n.neuroglancer-segment-list-entry:hover .neuroglancer-segment-list-entry-copy {\n  visibility: visible;\n}\n\n.neuroglancer-segment-list\n  .neuroglancer-segment-list-entry:not(:hover)\n  .neuroglancer-star-icon:not(.neuroglancer-starred) {\n  visibility: hidden;\n}\n\n.neuroglancer-segment-list\n  .neuroglancer-segment-list-entry:not(:hover)\n  .neuroglancer-eye-icon:not(.neuroglancer-visible) {\n  visibility: hidden;\n}\n\n.neuroglancer-segment-list-entry-visible-checkbox {\n  order: 1;\n}\n\n.neuroglancer-segment-list-entry-filter {\n  visibility: hidden;\n  grid-column: filter;\n  order: 999;\n}\n\n.neuroglancer-segment-list-entry:hover .neuroglancer-segment-list-entry-filter {\n  visibility: visible;\n}\n\n.neuroglancer-segment-query-result-tag-list {\n  display: grid;\n  grid-auto-rows: auto;\n  grid-template-columns: [include] min-content [exclude] min-content [tag] 1fr [count] min-content;\n}\n\n.neuroglancer-segment-query-result-tag {\n  display: contents;\n}\n\n.neuroglancer-segment-query-result-tag:hover * {\n  background-color: #222;\n}\n\n.neuroglancer-segment-query-result-tag-name {\n  grid-column: tag;\n  white-space: nowrap;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.neuroglancer-segment-query-result-tag-name::before {\n  content: \"#\";\n  color: #aaa;\n  font-weight: normal;\n}\n\n.neuroglancer-segment-query-result-tag-toggle {\n  display: inline-block;\n  white-space: nowrap;\n}\n\n.neuroglancer-segment-query-result-tag-include {\n  grid-column: include;\n}\n\n.neuroglancer-segment-query-result-tag-exclude {\n  grid-column: exclude;\n}\n\n.neuroglancer-segment-query-result-statistics {\n  background-color: #333;\n  max-height: 30%;\n  flex-shrink: 0;\n  overflow: auto;\n}\n\n.neuroglancer-segment-query-result-statistics:not(:empty) {\n  padding-top: 3px;\n}\n\n.neuroglancer-segment-query-result-statistics:not(:empty)\n  + .neuroglancer-segment-list-status {\n  border-top: 1px solid white;\n}\n\n.neuroglancer-segment-query-result-statistics-separator {\n  height: 3px;\n  background-color: #333;\n  border-bottom: 1px solid white;\n}\n\n.neuroglancer-segment-query-result-tag-count {\n  grid-column: count;\n  text-align: right;\n}\n\n.neuroglancer-segment-query-result-tag-count:not(:empty)::before {\n  content: \"(\";\n  color: #aaa;\n}\n\n.neuroglancer-segment-query-result-tag-count:not(:empty)::after {\n  content: \")\";\n  color: #aaa;\n}\n\n.neuroglancer-segment-query-result-numerical-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.neuroglancer-segment-query-result-numerical-plot-container {\n  justify-self: stretch;\n  display: flex;\n  flex-direction: column;\n  padding: 2px;\n}\n\n.neuroglancer-segment-query-result-numerical-plot {\n  display: block;\n  height: 30px;\n  cursor: ew-resize;\n  justify-self: stretch;\n  border: 1px solid #666;\n}\n\n.neuroglancer-segment-query-result-numerical-plot-bound {\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: none;\n  border: 0;\n  margin: 0;\n  font: 10pt sans-serif;\n  pointer-events: auto;\n}\n\n.neuroglancer-segment-query-result-numerical-plot-window-bound {\n  color: cyan;\n}\n\n.neuroglancer-segment-query-result-numerical-plot-range-bound {\n  color: white;\n}\n\n.neuroglancer-segment-query-result-numerical-plot-bounds {\n  display: flex;\n  flex-direction: row;\n  color: #aaa;\n}\n\n.neuroglancer-segment-query-result-numerical-plot-bound-constraint-symbol {\n  align-self: center;\n}\n\n.neuroglancer-segment-query-result-numerical-plot-bound-constraint-spacer {\n  flex: 1;\n  color: white;\n  font-weight: bold;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.neuroglancer-segment-query-result-numerical-plot-label {\n  cursor: pointer;\n}\n\n.neuroglancer-segment-query-result-numerical-plot-sort,\n.neuroglancer-segment-list-header-label-sort {\n  visibility: hidden;\n}\n\n.neuroglancer-segment-query-result-numerical-plot-label:hover\n  .neuroglancer-segment-query-result-numerical-plot-sort,\n.neuroglancer-segment-list-header-label:hover\n  .neuroglancer-segment-list-header-label-sort {\n  visibility: visible;\n}\n\n.neuroglancer-segment-query-result-numerical-plot-container:hover\n  .neuroglancer-segment-query-result-numerical-plot-bounds-window {\n  visibility: visible;\n}\n\n.neuroglancer-segment-query-result-numerical-plot-bounds-window {\n  justify-content: space-between;\n  margin-top: -16px;\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.neuroglancer-segment-list-entry.neuroglancer-segment-list-header {\n  background-color: #666;\n}\n\n.neuroglancer-segment-list-header .neuroglancer-segment-list-entry-id {\n  background-color: inherit;\n  color: white;\n  text-align: center;\n}\n\n.neuroglancer-segment-list-header-label {\n  cursor: pointer;\n  font: 10pt sans-serif;\n}\n\n.neuroglancer-segment-list-header\n  .neuroglancer-segment-list-entry-extra-property {\n  text-align: center;\n}\n\n.neuroglancer-segment-list-status-message {\n  overflow: hidden;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
